__turbopack_context__.v({
  "intro": "kJrq3G_intro",
  "primary": "kJrq3G_primary",
  "secondary": "kJrq3G_secondary",
  "station": "kJrq3G_station",
  "timezone": "kJrq3G_timezone",
  "timezone_toggle": "kJrq3G_timezone_toggle",
  "timezone_toggle__btn": "kJrq3G_timezone_toggle__btn",
  "toggle_bg": "kJrq3G_toggle_bg",
});
